module.exports = __webpack_public_path__ + "static/media/client-02.f8b5e6f9.png";